const breakpoint1023 = window.matchMedia('(max-width: 1023px)');
const initTabsSlider = () => {
  const sliders = document.querySelectorAll('.sber-meeting-rooms__slider');

  if (!sliders.length) {
    return;
  }

  sliders.forEach((slider) => {
    const container = slider.querySelector('.sber-meeting-rooms__slider-container');
    const slides = container.querySelectorAll('.sber-meeting-rooms__slider-slide');
    const btns = slider.querySelector('.sber-meeting-rooms__slider-btns');

    let swiper;

    const initSwiper = () => {
      // eslint-disable-next-line no-undef
      swiper = new Swiper(container, {
        slidesPerView: 'auto',
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        threshold: 10,
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
        },
      });
    };

    const reInitSwiper = () => {
      if (swiper) {
        swiper.destroy(true, true);
      }

      initSwiper();
    };

    initSwiper();

    breakpoint1023.addListener(reInitSwiper);
  });
};

export { initTabsSlider };
